document.addEventListener('DOMContentLoaded', async () => {
    console.log('✅ form_script.js loaded and DOM is ready');
  
    const observer = new MutationObserver(async (mutationsList, observer) => {
      const form = document.querySelector('form-embed');
  
      if (form) {
        observer.disconnect();
        const shadow = form.shadowRoot;
  
        try {
          const response = await fetch('/cdn/shop/t/1/assets/z-shopify_form_styling.css');
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const cssText = await response.text();
  
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(cssText);
          shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
  
          console.log('✅ External CSS applied to shadow DOM');
        } catch (error) {
          console.error('❌ Failed to load/apply external CSS:', error);
        }
  
        // Function to move output errors into their correct containers
        const relocateOutputErrors = (root) => {
          const outputs = root.querySelectorAll('output[role="alert"]._formError_1ydxd_20');
  
          outputs.forEach(output => {
            const prev = output.previousElementSibling;
            let container = prev?.classList.contains('_formFieldContainer_1ydxd_5')
              ? prev
              : prev?.closest('._formFieldContainer_1ydxd_5');
  
            if (container && !container.contains(output)) {
              container.appendChild(output);
              console.log(`✅ Moved error to container for: ${output.textContent.trim()}`);
            }
          });
        };
  
        // Observe for newly added output elements
        const errorObserver = new MutationObserver(() => {
          relocateOutputErrors(shadow);
        });
  
        errorObserver.observe(shadow, { childList: true, subtree: true });
  
        // Initial run just in case some errors already exist
        relocateOutputErrors(shadow);
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  });
  